import { Skeleton } from '@app/components/various/Skeleton';
import { isDefined } from '@app/utils/is';
import { flexRender } from '@tanstack/react-table';
import { Tables } from '@typings';

export const TableCardFooter = <T,>({ table, isLoading }: Tables.FooterProps<T>) => {
  const footerGroups = table.getFooterGroups();

  const hasFooter = footerGroups.some(footerGroup => footerGroup.headers.some(header => isDefined(header.column.columnDef.footer)));

  if (!hasFooter) {
    return null;
  }

  if (isLoading) {
    return <Skeleton type="text" rows={2} width={25} lastWidth={100} gap="large" containerClassName="mt-3 mx-4" />;
  }

  return footerGroups.map(footerGroup => {
    const [firstHeader, ...restHeaders] = footerGroup.headers.filter(header => isDefined(header.column.columnDef.footer));

    if (!isDefined(firstHeader) || !isDefined(restHeaders)) {
      return null;
    }

    return (
      <div className="px-4 pt-3 text-neutral-40 body-2" key={footerGroup.id}>
        <span>{flexRender(firstHeader.column.columnDef.footer, firstHeader.getContext())}</span>
        <div className="mt-1 flex flex-wrap justify-between gap-x-8 gap-y-4">
          {restHeaders.map(header => (
            <div className="gap-2 last:text-right has-[:empty]:hidden" key={header.id}>
              <div className="body-4">{flexRender(header.column.columnDef.header, header.getContext())}:</div>
              <div className="text-neutral-20 body-1">{flexRender(header.column.columnDef.footer, header.getContext())}</div>
            </div>
          ))}
        </div>
      </div>
    );
  });
};
